export default __webpack_public_path__ + "static/media/edi-electrodeionization.90b16faa.png";